module.exports = __webpack_public_path__ + "img/truck_banner.48443006.jpg";